// Application Routes
export const ROUTES = {
  // Public Auth Routes
  login: '/login',
  signUp: '/sign-up',
  resetPassword: '/reset-password',

  // Employer Routes (Protected)
  employer: '/employer',
  employerDashboard: 'dashboard',
  employerCandidates: 'candidates',
  employerCandidateResults: 'candidate-results',
  employerViewResult: 'candidate-results/:candidateId',
  employerInterviewConfig: 'interview-config',
  employerApiKeys: 'api-keys',
  employerPlan: 'plan',
  employerSettings: 'settings',

  // Candidate Routes
  initialRoute: '/',
  interviewGuidelines: '/interview-guidelines',
  selectDate: '/select-date',
  timeSlot: '/time-slot',
  scheduleSuccess: '/schedule-success',
  thankYou: '/thank-you',
  interviewLanding: '/interview-landing',
  interviewInstructions: '/interview-instructions',
  interviewTesting: '/interview-testing',

  // Full screen interview routes (no layout)
  liveInterview: '/live-interview',
  aiInterview: '/ai-interview',
  instantInterview: '/instant-interview',

  // Interview Results module routes
  interviewResultsRoot: '/interview-results',
  interviewResultsAllCandidates: '/interview-results/all-candidates',
  interviewResultsView: '/interview-results/view/:candidateUid',

  // Coding Round Routes
  codingRoundInitial: '/coding-round-initial',
  codingRound: '/coding-round',
  codingRoundResult: '/coding-round-result',

  // Error Routes
  unauthorized: '/unauthorized',
  notFound: '*',
} as const;

// Helper to generate path with params
export const generatePath = (
  path: string,
  params: Record<string, string>
): string => {
  let result = path;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(`:${key}`, value);
  });
  return result;
};
